import { NsCard } from 'components/common/ns-card/NsCard';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';

export const testId = 'personalInformationPlaybackTestId';

type Item = {
  title: string;
  handler: () => void;
  content: React.ReactNode;
  canEdit: boolean;
};

type PersonalInformationPlaybackProps = {
  items?: Item[];
};

export const PersonalInformationPlayback = ({ items = [] }: PersonalInformationPlaybackProps) => {
  return items.map(({ title, handler, content, canEdit }, index) => (
    <NsCard
      key={`${title}-${index}`}
      type="support"
      heading={title}
      action={
        canEdit && <NsSecondaryCta onClick={handler}>Edit</NsSecondaryCta>
      }
    >
      {content}
    </NsCard>
  ));
};
